import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  // getCampaignList,
  getGridDataByModuleKey,
  getLeadById,
  getLeadList,
} from '../../redux/selector';
import {
  fetchDataAndUpdateStore,
  fetchNotesAndAppendToModule,
  fetchAttachmentsAndAppendToModule,
  fetchCampaignsAndAppendToModule,
  fetchEmailAndAppendToModule,
  fetchTagsAndAppendToModule,
  fetchDetailAndAppendToModule,
} from '../../redux/actions';
import LeadForm from './leadForm';
import { useDispatch, useSelector } from 'react-redux';
import { DetailDateFormatter } from '../../shared/controls/formatters';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import Loader from '../../shared/component/Loader';
import Notes from '../sharedChild/note/notes';
import HeaderProfileBlock from '../sharedChild/headerImage/headerProfileBlock';
import Attachments from '../sharedChild/attachment/attachments';
import Email from '../sharedChild/email/emails';
import ChildCampaign from '../sharedChild/childCampaign';
import { leadInputData } from '../../shared/constants';
import MassEmail from './massEmail';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import ComposeEmail from '../sharedChild/email/compose';
import Timeline from '../sharedChild/timeline';
import aiImage from '../../../src/assets/img/crm_home/header/ai.png';
import convert from '../../../src/assets/img/crm_home/header/convert.png';
import edit from '../../../src/assets/img/crm_home/header/edit.png';
import send from '../../../src/assets/img/crm_home/header/send.png';
import addNote from '../../../src/assets/img/crm_home/header/addNote.png';
import Enrichment from './leadEnrichment';

const validationSchema = Yup.object().shape({
  businessType: Yup.string().required('Business Type is required'),
  industry: Yup.string().required('Industry is required'),
});

const ViewLead = () => {
  const refs = {
    overview: useRef(null),
    attachments: useRef(null),
    campaigns: useRef(null),
    emails: useRef(null),
    timeline: useRef(null),
  };
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const stateData = useSelector((state) => state);
  let storeLoading = isLoadingByKey(stateData, 'leads');
  const [formData, setFormData] = useState({});
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [loading, setLoading] = useState(false);
  const [enrichedDataLoading, setEnrichedDataLoading] = useState(false);

  const [activeTab, setActiveTab] = useState('overview');
  const [sentData, setSentData] = useState([]);
  const [draftData, setDraftData] = useState([]);
  const [scheduledData, setScheduledData] = useState([]);
  const [isEnrichedFlag, setIsEnrichedFlag] = useState(false);
  const leadList = useSelector(getLeadList);
  const gridData = useSelector(getGridDataByModuleKey('leads'));

  let hasUpdateCampaignPermission = true;
  let hasViewCampaignPermission = true;
  let userUIControlPermission = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.campaignmenu;

  if (userUIControlPermission) {
    hasViewCampaignPermission = userUIControlPermission?.campaignviewscreen
      ? userUIControlPermission.campaignviewscreen.canView
      : true;

    hasUpdateCampaignPermission = userUIControlPermission?.campaignupdatescreen
      ? userUIControlPermission.campaignupdatescreen.canView
      : true;
  }

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  const searchParams = new URLSearchParams(location.search);
  const leadID = searchParams.get('id');
  const [leadLocalData, setLeadLocalData] = useState(location.state || {});
  const leadStoreData = useSelector((state) => {
    const leadId = location.state?.id || leadID; // Use the pre-fetched `leadID`
    return getLeadById(state, leadId);
  });

  useEffect(() => {
    setLeadLocalData((prev) => ({ ...prev, ...leadStoreData }));
  }, [leadStoreData]);
  //   const leadLocalData = useSelector((state) => {
  //     if(location.state)
  //       return location.state;

  //   const leadId = leadID; // Use the pre-fetched `leadID`
  //   return getLeadById(state, leadId);
  // });

  const scrollToSection = (id) => {
    if (refs[id]?.current) {
      refs[id].current.scrollIntoView({
        behavior: 'smooth', // Smooth scrolling
        block: 'center', // Aligns the section close to the center
        inline: 'nearest',
      });

      // Slightly adjust the position to be a bit above the center
      setTimeout(() => {
        const offset = -50; // Adjust this value for how much higher you want
        const elementPosition =
          refs[id].current.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
      }, 300); // Adjust timeout if necessary for smoother behavior
    }
  };

  useEffect(() => {
    if (leadLocalData?.emails) {
      const { sent, draft, scheduled } = leadLocalData?.emails?.reduce(
        (acc, item) => {
          if (item.status === 'Sent') acc.sent.push(item);
          else if (item.status === 'Draft') acc.draft.push(item);
          else if (item.status === 'Scheduled') acc.scheduled.push(item);
          return acc;
        },
        { sent: [], draft: [], scheduled: [] }
      );

      setSentData(sent);
      setDraftData(draft);
      setScheduledData(scheduled);
    }
    if (leadLocalData?.isEnriched) {
      setIsEnrichedFlag(leadLocalData?.isEnriched);
    }
  }, [leadLocalData]);

  useEffect(() => {
    // Add event listener for Bootstrap tab changes
    const handleTabShown = (event) => {
      setActiveTab(event.target.getAttribute('href').replace('#', ''));
    };

    document
      .querySelectorAll('[data-bs-toggle="tab"]')
      .forEach((tab) => tab.addEventListener('shown.bs.tab', handleTabShown));

    return () => {
      // Cleanup event listeners
      document
        .querySelectorAll('[data-bs-toggle="tab"]')
        .forEach((tab) => tab.removeEventListener('shown.bs.tab', handleTabShown));
    };
  }, []);

  // const campaignListAll = useSelector(getCampaignList);
  const handleFormSubmit = () => {};

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };
  const handleDropdownChange = (selectedId, e, name, displayName, flag) => {
    const selectedValue = e.currentTarget.textContent;

    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
      [displayName]: undefined,
    }));
    setFormData({
      ...formData,
      [name]: selectedId,
      [displayName]: selectedValue,
    });

    setFormEdited(true);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));

    const updatedFormData = {
      ...formData,
      [name]: selectedId,
      [`${name}Name`]: selectedValue,
    };
    if (name === 'revenueTypeId') {
      setFormData({
        ...formData,
        revenueTypeId: selectedId,
        revenueType: selectedValue,
      });

      setFormEdited(true);
    } else if (name === 'leadSourceId') {
      setFormData({
        ...formData,
        leadSourceId: selectedId,
        leadSource: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'industryId') {
      setFormData({
        ...formData,
        industryId: selectedId,
        industry: selectedValue,
      });
      setFormEdited(true);
    }
  };
  const handleSubmit = async (noteData) => {
    const updatedNoteData = {
      ...noteData,
      moduleId: location.state?.id,
      module: 'Lead',
    };

    if (noteData.type === 'edit') {
      apiServices
        .updateNote(updatedNoteData)
        .then((response) => {
          if (response.status === 200) {
            closePopup6();
            dispatch(
              fetchNotesAndAppendToModule({
                moduleName: 'Lead',
                id: location.state?.id,
              })
            );
            setLoading(false);
            toast.success('Notes Updated successfully!', {
              position: 'top-right',
            });
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          console.error('Error:', error, 'DataFormat:', formData);
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
          setLoading(false);
        });
    } else {
      apiServices
        .createNote(updatedNoteData)
        .then((response) => {
          if (response.status === 200) {
            dispatch(
              fetchNotesAndAppendToModule({
                moduleName: 'Lead',
                id: location.state?.id,
              })
            );
            setLoading(false);
            toast.success('Notes Added successfully!', {
              position: 'top-right',
            });
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          console.error('Error:', error, 'DataFormat:', formData);
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
          setLoading(false);
        });
    }
  };

  const handleClickOpenConvertLead = () => {
    navigate('/leads/convertLead', {
      state: formData,
    });
  };
  const [isExpand, setIsExpand] = useState(false);

  const handleExpand = () => {
    setIsExpand((prev) => !prev);
  };

  const [image, setImage] = useState(null);
  const [imageName, setImageName] = useState('');
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage(e.target.result); // Set the uploaded image URL
        setImageName(file.name); // Set the name of the uploaded image
        setIsMenuVisible(true); // Show the menu after the upload
      };
      reader.readAsDataURL(file);
    }
  };

  const handleEditClick = () => {
    document.getElementById('image-upload-input').click(); // Trigger file input click
  };
  const handleRemoveImage = () => {
    setImage(null); // Clear the image
    setImageName(''); // Clear the image name
    setIsMenuVisible(false); // Hide the menu when the image is removed
  };
  const [selectedLink, setSelectedLink] = useState(null);
  const handleLinkClick = (link) => {
    // Set the clicked link as the selected one
    setSelectedLink(link);
  };

  // ______________________
  const [isOpen, setIsOpen] = useState(false);

  // State to control popup visibility
  const [showPopup, setShowPopup] = useState(false);

  // Function to handle opening the popup
  const openPopup = () => {
    setShowPopup(true);
  };

  const [showPopup4, setShowPopup4] = useState(false);
  const [showPopup5, setShowPopup5] = useState(false);
  const [showPopupLead, setShowPopupLead] = useState(false);
  const [leadEnrichedData, setLeadEnrichedData] = useState();
  const [showPopup6, setShowPopup6] = useState(false);

  // Function to open the fifth popup
  const openPopup5 = () => {
    setShowPopup5(true);
  };

  // Function to close the fifth popup
  const closePopup5 = () => {
    setShowPopup5(false);
    setShowPopup4(false);
  };

  // Function to open the fifth popup
  const openPopupLead = () => {
    setShowPopupLead(true);
  };

  // Function to close the fifth popup
  const closePopupLead = () => {
    setShowPopupLead(false);
  };

  const [showMassEmailPopup, setMassEmailPopup] = useState(false);

  const openMassEmailPopup = () => {
    setMassEmailPopup(true);
  };

  const closeMassEmailPopup = () => {
    setMassEmailPopup(false);
  };

  const [showSelectTemplatePopup, setSelectTemplatePopup] = useState(false);

  const openSelectTemplatePopup = () => {
    setSelectTemplatePopup(true);
  };

  const closeSelectTemplatePopup = () => {
    setSelectTemplatePopup(false);
  };

  // ______________________________table end_________

  const customStyles = {
    control: (base, state) => ({
      ...base,
      border: state.isFocused ? '2px solid transparent' : '1px solid transparent',
      borderRadius: '5px',
      boxShadow: state.isFocused ? 'none' : 'none',
      ':hover': {
        borderColor: 'transparent',
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: '#888',
      fontSize: '.8rem',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      display: 'none', // Hide the dropdown arrow
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: '#E7F2FF',
      borderRadius: '50px',
      padding: '5px 14px',
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: '#707070',
      fontSize: '.8rem',
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: '#4caf50',
      ':hover': {
        backgroundColor: '#d32f2f',
        color: '#fff',
      },
    }),
  };

  const closePopup6 = () => {
    setShowPopup6(false);
  };

  const openPopup6 = () => {
    setShowPopup6(true);
  };
  const handleOpenEditForm = (paramsValue) => {
    navigate('/leads/editLead', {
      state: formData,
    });
  };

  const [refreshLeadView, setRefreshLeadView] = useState(false);

  useEffect(() => {
    const leadId = location.state?.id || leadID;

    if (location.pathname.includes('viewLead')) {
      setFormData({
        ...leadLocalData,
        type: 'view',
        from: 'view',
      });
    }
    // if (leadList && leadList.length > 0 && leadId) {
    if (leadId) {
      dispatch(
        fetchDetailAndAppendToModule({
          moduleName: 'Lead',
          id: leadId,
          localDetail: location.state || null,
        })
      );
      dispatch(
        fetchNotesAndAppendToModule({
          moduleName: 'Lead',
          id: leadId,
        })
      );
      dispatch(
        fetchAttachmentsAndAppendToModule({
          moduleName: 'Lead',
          id: leadId,
        })
      );
      dispatch(
        fetchCampaignsAndAppendToModule({
          moduleName: 'Lead',
          id: leadId,
        })
      );
      dispatch(
        fetchEmailAndAppendToModule({
          moduleName: 'Lead',
          id: leadId,
        })
      );
      dispatch(
        fetchTagsAndAppendToModule({
          moduleName: 'Lead',
          id: leadId,
        })
      );
    }
  }, [location, leadLocalData?.id, refreshLeadView]);

  const handleClickDelete = (paramsValue) => {
    setLoading(true);
    // Creating the desired JSON object
    const data = {
      id: paramsValue.id,
    };
    console.log('Data==>>', data);
    apiServices
      .deleteNote(data)
      .then((response) => {
        if (response.status === 200) {
          dispatch(
            fetchNotesAndAppendToModule({
              moduleName: 'Lead',
              id: location.state?.id,
            })
          );
          setLoading(false);
          toast.success('Note Deleted Successfully!', {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        console.error('Error while deleting lead:', error);
        setLoading(false);
      });
  };

  const handleClickDeleteCampaign = (paramsValue) => {
    setLoading(true);
    // Creating the desired JSON object
    const data = {
      moduleId: paramsValue.id,
      module: 'Lead',
    };
    console.log('Data==>>', data);
    apiServices
      .deleteCampaignByModule(data)
      .then((response) => {
        if (response.status === 200) {
          dispatch(
            fetchCampaignsAndAppendToModule({
              moduleName: 'Lead',
              id: location.state?.id,
            })
          );
          setLoading(false);
          toast.success('Campaign Deleted Successfully!', {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        console.error('Error while deleting lead:', error);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (showPopup5) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto'; // Cleanup
    };
  }, [showPopup5]);

  const handleClickDataEnrichment = (paramsValue) => {
    if (leadLocalData.firstName === '' || leadLocalData.lastName === '') {
      toast.error('Please fill in the first name and last name fields.', {
        position: 'top-right',
      });
      return;
    }
    setEnrichedDataLoading(true);

    // Creating the desired JSON object
    const data = {
      LeadName: `${leadLocalData.fullName}`,
      CompanyName: `${leadLocalData.companyName}`,
      EnrichmentType: 'leads',
    };

    const fetchEnrichedData = () => {
      apiServices
        .getEnrichedData(data)
        .then((response) => {
          if (response.status === 200) {
            console.log('Data==>>', response.data);
            setLeadEnrichedData(response.data?.enriched_data);
            setEnrichedDataLoading(false);
            openPopupLead();
            apiServices
              .updateEnrichedFlag(
                {
                  id: leadLocalData.id,
                },
                'Lead'
              )
              .then((res) => {
                if (res.status === 200) {
                  if (res.status === 200) {
                    setIsEnrichedFlag(true); // Set the enriched flag to true
                  }
                }
              })
              .catch((error) => {
                console.error('Error updating enriched flag:', error);
                toast.error('Failed to update enriched flag.', {
                  position: 'top-right',
                });
              });
          } else if (response.status === 202) {
            toast.info('Enrichment Initiated! Retrying in 2 minutes...', {
              position: 'top-right',
            });
            setTimeout(fetchEnrichedData, 120000); // Retry after 2 minutes
          }
        })
        .catch((error) => {
          console.error('Error while fetching enriched data:', error);

          // Safely extract error message from response
          const errorMsg = error?.response?.data?.error || 'An unexpected error occurred.';

          toast.error(errorMsg, {
            position: 'top-right',
          });

          setEnrichedDataLoading(false);
        });
    };

    fetchEnrichedData();
  };

  const handleUpdateForm = async (formData) => {
    setLoading(true);
    try {
      const response = await apiServices.updateLead(formData);

      if (response.status === 200) {
        // ✅ Await dispatch before toggling the refresh flag
        await dispatch(
          fetchDataAndUpdateStore({
            key: 'leads',
            inputData: gridData?.inputPayload ? gridData.inputPayload : leadInputData,
          })
        );

        setShowPopup5(false);
        setShowPopup4(false);
        closePopupLead();
        setLoading(false);

        // ✅ This now happens after dispatch is complete
        setRefreshLeadView((prev) => !prev);
      } else {
        setLoading(false);
        const errorMessages = [];
        for (const key in response.errors) {
          if (response.errors.hasOwnProperty(key)) {
            const messages = response.errors[key];
            errorMessages.push(...messages);
          }
        }
        errorMessages.forEach((errorMessage) => {
          toast.error(errorMessage, { position: 'top-right' });
        });
      }
    } catch (error) {
      console.error('Error:', error, 'DataFormat:', formData);
      toast.error('An unexpected error occurred.', {
        position: 'top-right',
      });
      setLoading(false);
    }
  };

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      root: scrollContainerRef.current,
      rootMargin: '-200px 0px 0% 0px', // Adjusts the bottom margin to trigger when the section is halfway through the viewport
      threshold: 0,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          setActiveTab(sectionId);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe each section
    Object.values(refs).forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    // Cleanup on unmount
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    console.log('Active Tab:', activeTab);
  }, [activeTab]);

  return (
    <>
      {loading && <Loader />}

      <div className="ViewLeadPageOuter">
        <div className="viewHeader">
          <HeaderProfileBlock localData={leadLocalData} moduleName={'Lead'} View={true} />
          <div className="rightActionDskButton">
            <div className="rightAction">
              {console.log('isEnrichedFlag', isEnrichedFlag)}
              {leadLocalData?.isEnriched || isEnrichedFlag ? (
                <button className="btn btn-outline-primary" onClick={handleClickDataEnrichment}>
                  {enrichedDataLoading && (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                  {enrichedDataLoading ? (
                    'Loading...'
                  ) : (
                    <>
                      <img
                        src={aiImage}
                        alt="AI Icon"
                        className="me-2"
                        style={{ width: '14px', height: '14px' }}
                      />
                      <span className="btnText">Refresh Enriched Data </span>
                    </>
                  )}
                </button>
              ) : (
                <button
                  className="btn btn-outline-primary"
                  onClick={handleClickDataEnrichment}
                  disabled={enrichedDataLoading} // Disable button when loading
                >
                  {enrichedDataLoading && (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}

                  {enrichedDataLoading ? (
                    <span className="btnText">Loading...</span>
                  ) : (
                    <>
                      <img
                        src={aiImage}
                        alt="AI Icon"
                        className="me-2"
                        style={{ width: '14px', height: '14px' }}
                      />
                      <span className="btnText">Get Enriched Data </span>
                    </>
                  )}
                </button>
              )}

              <button className="btn btn-outline-primary" onClick={handleClickOpenConvertLead}>
                {' '}
                <img
                  src={convert}
                  alt="Convert"
                  className="me-2"
                  style={{ width: '14px', height: '14px' }}
                />
                <span className="btnText">Convert</span>
              </button>
              <button
                className="btn btn-outline-primary"
                onClick={handleOpenEditForm}
                disabled={!formData}
              >
                <img
                  src={edit}
                  alt="Edit"
                  className="me-2"
                  style={{ width: '12px', height: '12px' }}
                />
                <span className="btnText"> Edit</span>
              </button>

              <button
                className="btn btn-outline-primary actbtn sendEmailBtn"
                onClick={openPopup5}
                disabled={leadLocalData?.emailOptOut === true}
              >
                <img
                  src={send}
                  alt="Send"
                  className="me-2"
                  style={{ width: '14px', height: '14px' }}
                />
                {/* Send{" "} */} <span className="btnText">Send Email</span>
              </button>
              <div id="sendmail">
                {showPopup5 && (
                  <ComposeEmail
                    localData={leadLocalData}
                    module={'Lead'}
                    handleClose={closePopup5}
                    handleChange={handleChange}
                  />
                )}
              </div>
            </div>
            <div className="mob">
              <div className="adnoteMob ms-2">
                <button
                  className="btn btn-primary"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasExample"
                  aria-controls="offcanvasExample"
                >
                  <img
                    src={addNote}
                    alt="Add a Note"
                    className="me-2"
                    style={{ width: '12px', height: 'auto' }}
                  />
                  <span className="btnText">Add a Note</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="detailContainer" ref={scrollContainerRef}>
          <div className="viewFormContainer">
            <div className="leftBlock">
              <ul>
                {Object.keys(refs).map((key) => (
                  <li
                    key={key}
                    onClick={() => scrollToSection(key)}
                    style={{ cursor: 'pointer' }}
                    className={activeTab === key ? 'leftbox activeList' : 'leftbox'}
                  >
                    <button onClick={() => setActiveTab(key)}>
                      {key.charAt(0).toUpperCase() + key.slice(1)}
                      {['openActivities', 'closedActivities', 'invitedMeetings'].includes(key) && (
                        <span style={{ fontSize: '7px', fontWeight: '600' }}> (Coming Soon)</span>
                      )}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rightBlock" id="detailPageRight" data-bs-spy="scroll">
              <div className="addlead_container">
                <Formik initialValues={formData} validationSchema={validationSchema}>
                  <Form id="viewForm">
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12">
                        <div id="overview" className="scrollTo" ref={refs.overview}></div>
                        <div className="addleadcard1">
                          {formData && (
                            <LeadForm formData={formData} selectedOptions={selectedOptions} />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="tab-content">
                      <div>
                        <div>
                          <div>
                            <div></div>
                          </div>
                        </div>

                        <div id="attachments" className="scrollTo" ref={refs.attachments}></div>
                        <Attachments localData={leadLocalData} module={'Lead'} />

                        {hasViewCampaignPermission && (
                          <>
                            <div id="campaigns" className="scrollTo" ref={refs.campaigns}></div>
                            <ChildCampaign
                              localData={leadLocalData}
                              module={'Lead'}
                              hasUpdateCampaignPermission={hasUpdateCampaignPermission}
                            />
                          </>
                        )}

                        <div id="emails" className="scrollTo" ref={refs.emails}></div>
                        <Email localData={leadLocalData} module={'Lead'} />
                      </div>
                      <div id="timeline" className="scrollTo" ref={refs.timeline}></div>
                      <Timeline localData={leadLocalData} module={'Lead'} />
                    </div>
                  </Form>
                </Formik>
              </div>
            </div>
          </div>
          <div className="viewFormNotesOuter">
            <div className="ViewFormNotesContainer">
              <Formik initialValues={formData} validationSchema={validationSchema}>
                <Form id="viewForm">
                  <Notes leadLocalData={leadLocalData} module={'Lead'}></Notes>
                </Form>
              </Formik>
            </div>
          </div>
        </div>

        <div
          className="offcanvas addNoteMobBlock offcanvas-end"
          tabindex="-1"
          id="offcanvasExample"
          aria-labelledby="offcanvasExampleLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasExampleLabel">
              <img src="../assets/images/notesIcon.svg" alt="Note" width="16px" />
              Notes
            </h5>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            <div className="ViewFormNotesContainer">
              <Formik
                initialValues={formData}
                // onSubmit={(values) => handleSubmit(values)}
                validationSchema={validationSchema}
              >
                <Form id="viewForm">
                  <Notes leadLocalData={leadLocalData} module={'Lead'}></Notes>
                </Form>
              </Formik>
            </div>
          </div>
        </div>
      </div>
      {showMassEmailPopup && <MassEmail handleClose={closeMassEmailPopup} />}

      {showPopupLead && (
        <Enrichment
          handleClose={closePopupLead}
          localData={leadLocalData}
          enrichedData={leadEnrichedData}
          handleSave={handleUpdateForm}
          loading={loading}
        />
      )}
    </>
  );
};

function TabContent({ data }) {
  return (
    <div className="tableContainer">
      <table>
        <thead>
          <tr>
            <th>
              <input type="checkbox" />
            </th>
            <th width="27.5%">Subject</th>
            <th>Message</th>
            <th>Date</th>
            <th>From Address</th>
            <th width="8%">Action</th>
          </tr>
        </thead>
        <tbody>
          {data?.length === 0 ? (
            <tr>
              <td colSpan="6" style={{ textAlign: 'center' }}>
                No Records
              </td>
            </tr>
          ) : (
            data?.map((item) => (
              <tr key={item.id}>
                <td>
                  <input type="checkbox" />
                </td>
                <td className="cName">
                  <p>{item.subject}</p>
                </td>
                <td>{item.message}</td>
                <td>{DetailDateFormatter(item.scheduledTime)}</td>
                <td>
                  <a href={`mailto:${item.fromAddress}`} title="">
                    <span className="mailLink">{item.fromAddress}</span>
                  </a>
                </td>
                <td>
                  <div className="actionButton">
                    <img src="/assets/images/eye.png" alt="View" width="18px" />
                    <img src="/assets/images/editNotes.png" alt="Edit" width="14px" />
                    <img src="/assets/images/deleteNotes.png" alt="Delete" width="18px" />
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default ViewLead;
